import { ROLE } from './roles.js';
/** Restore the existing planner workspace without changing accounts or role permissions. */
export const PLANNER_WORKSPACE_ENABLED = true;
/** ARCA owns design draft authoring. Keep historical records readable in DS. */
export const DESIGNER_DRAFT_AUTHORING_ENABLED = false;
/** DS receives SAP styles; native single/batch manual creation is retired. */
export const MANUAL_SHEET_CREATION_ENABLED = false;
/** SAP is the style/order source. Retire OrderEase push, pull and intake corrections. */
export const ORDER_SYSTEM_INTAKE_ENABLED = false;
/** Cost entry and calculations are deferred from the current sheet detail workspace. */
export const SHEET_COST_WORKSPACE_ENABLED = false;
export function isLaunchRoleEnabled(role) {
    return role !== ROLE.PLANNER || PLANNER_WORKSPACE_ENABLED;
}
//# sourceMappingURL=launch-scope.js.map